export enum Routes {
    LANDING_PAGE = '/',
    SERVICES_PAGE = "/services",
    ABOUT_PAGE = "/about",
    BLOG_PAGE = "/blog",
    CONTACT_PAGE = "/contact"
}
